// src/pages/NotFound.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Hemos buscado!</h1>
      <h3>pero no encontramos ésta página!</h3>
      <a href="/"><img src="/img/404.jpg" alt="Not found" /></a>
      <Link to="/">Go back to the homepage</Link>
    </div>
  );
};

export default NotFound;
